import React from "react";
import AuthorizationProvider from "./features/auth/AuthorizationProvider";
import Loader from "./components/loaders/Loader";
import { withAuthenticationRequired } from "@auth0/auth0-react";
import UserDataProvider from "./features/user/UserDataProvider";

const Main = React.lazy(() => import("./features"));

const App = () => {
  return (
    <AuthorizationProvider>
      <UserDataProvider>
        <React.Suspense fallback={<Loader />}>
          <Main />
        </React.Suspense>
      </UserDataProvider>
    </AuthorizationProvider>
  );
};

export default withAuthenticationRequired(App, {
  onRedirecting: () => <Loader />,
});
